"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#686D84' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2L0 16H12.276L16 12.276V2C16 1.46957 15.7893 0.960859 15.4142 0.585786C15.0391 0.210714 14.5304 0 14 0V0ZM12 14.3907V12H14.3907L12 14.3907ZM14.6667 10.6667H10.6667V14.6667H1.33333V2C1.33333 1.82319 1.40357 1.65362 1.5286 1.5286C1.65362 1.40357 1.82319 1.33333 2 1.33333H14C14.1768 1.33333 14.3464 1.40357 14.4714 1.5286C14.5964 1.65362 14.6667 1.82319 14.6667 2V10.6667ZM8.5 3.33333H10.6753V4.16667H9.33333V4.92533H10.576V5.75867H9.33333V7.35H8.5V3.33333ZM3.5 4.66667V6.04533C3.4992 6.11125 3.51158 6.17666 3.53641 6.23772C3.56124 6.29878 3.59803 6.35427 3.64461 6.40091C3.6912 6.44756 3.74663 6.48442 3.80766 6.50933C3.86869 6.53425 3.93408 6.54672 4 6.546C4.13043 6.54452 4.25525 6.49272 4.34842 6.40142C4.44158 6.31013 4.49588 6.18638 4.5 6.056V6H4V5.33333H5.33333V6.056C5.33052 6.40777 5.1888 6.74417 4.93906 6.99192C4.68931 7.23967 4.35178 7.37868 4 7.37867C3.82558 7.37946 3.65271 7.34586 3.49129 7.2798C3.32986 7.21374 3.18303 7.11651 3.0592 6.99368C2.93537 6.87084 2.83697 6.7248 2.76961 6.5639C2.70226 6.40301 2.66728 6.23042 2.66667 6.056V4.656C2.66728 4.48158 2.70226 4.30899 2.76961 4.1481C2.83697 3.9872 2.93537 3.84116 3.0592 3.71833C3.18303 3.59549 3.32986 3.49826 3.49129 3.4322C3.65271 3.36614 3.82558 3.33254 4 3.33333C4.35292 3.33561 4.69074 3.47681 4.9403 3.72637C5.18986 3.97593 5.33106 4.31375 5.33333 4.66667H4.5C4.4963 4.53523 4.44244 4.41018 4.34946 4.31721C4.25648 4.22423 4.13144 4.17036 4 4.16667C3.9342 4.16604 3.86893 4.17855 3.80802 4.20347C3.74711 4.22838 3.69179 4.2652 3.64529 4.31176C3.59879 4.35833 3.56204 4.4137 3.53721 4.47464C3.51238 4.53558 3.49995 4.60086 3.50067 4.66667H3.5ZM6.5 3.33333H7.33333V7.37933H6.5V3.33333Z",
    fill: fill
  }));
};

exports["default"] = _default;